import react from 'react';
const TableHeader = (props) => {
  return <thead className="bg-gray-50">{props.children}</thead>;
};
export default TableHeader;
